export const SELF_SIGNUP_OAUTH_STATE_KEY = 'liscio:self-signup-oauth-state';
export const SELF_SIGNUP_INVITATION_TOKEN_KEY = 'liscio:self-signup-invitation-token';
